import { render } from "./PsychicExpandedCard.vue?vue&type=template&id=f947f48c&scoped=true"
import script from "./PsychicExpandedCard.vue?vue&type=script&lang=js"
export * from "./PsychicExpandedCard.vue?vue&type=script&lang=js"

import "./PsychicExpandedCard.vue?vue&type=style&index=0&id=f947f48c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f947f48c"]])

export default __exports__